import { FormLabel } from "react-bootstrap";
import { HoverInfo } from "./Tooltip";

interface Props {
  label: string;
  toolTip?: string;
  titleCase?: boolean;
  className?: string;
}

/**
 * @deprecated Use fields folder and RAC instead
 */
const FormGroupLabel = ({ label, toolTip, titleCase, className }: Props) => (
  <FormLabel>
    <h6
      className={`title ${className ? className : ""}`}
      style={{
        color: "#73706E",
        fontWeight: "700",
        textTransform: titleCase ? "none" : "inherit",
      }}
    >
      {label}
      {toolTip && (
        <HoverInfo iconCss={{ display: "inline", paddingStart: "small", color: "grey" }}>{toolTip}</HoverInfo>
      )}
    </h6>
  </FormLabel>
);

export default FormGroupLabel;
